import { render } from "./CustomerFormShort.vue?vue&type=template&id=5adcbc1c"
import script from "./CustomerFormShort.vue?vue&type=script&lang=js"
export * from "./CustomerFormShort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__